/**
 * @file Web Gallery Blog container.
 */

import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import WebGalleryBlogPost from '../components/WebGalleryBlogPost';
import { AlbumFolderForWebGalleries } from '../graphql/queries/album-folder';
import {
  AlbumForWebGalleries,
  AlbumPhotoGroupWithBlogPosts,
} from '../graphql/queries/album';
import { BlogPost } from '../graphql/queries/blog';

const withAlbumData = graphql(AlbumForWebGalleries, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
    },
  }),
  props: ({ data: { album, loading } }) => ({
    entity: album,
    loadingEntity: loading,
  }),
  skip: ({ match }) => !match.params.albumId || match.params.photoGroupId,
});

const withAlbumFolderData = graphql(AlbumFolderForWebGalleries, {
  options: ({ match }) => ({
    variables: {
      id: match.params.folderId,
    },
  }),
  props: ({ data: { albumFolder, loading } }) => ({
    entity: albumFolder,
    loadingEntity: loading,
  }),
  skip: ({ match }) => !match.params.folderId,
});

const withAlbumPhotoGroupWithBlogPosts = graphql(AlbumPhotoGroupWithBlogPosts, {
  options: ({ match }) => ({
    variables: {
      id: match.params.photoGroupId,
    },
  }),
  props: ({ data: { albumPhotoGroup, loading } }) => ({
    entity: albumPhotoGroup,
    loadingEntity: loading,
  }),
  skip: ({ match }) => !match.params.photoGroupId,
});

const withBlogPost = graphql(BlogPost, {
  options: ({ match }) => ({
    variables: {
      id: match.params.blogPostId,
    },
  }),
  props: ({ data: { blogPost, loading } }) => ({
    loading,
    blogPost,
  }),
});

export default compose(
  withRouter,
  withAlbumData,
  withAlbumFolderData,
  withBlogPost,
  withAlbumPhotoGroupWithBlogPosts,
)(WebGalleryBlogPost);
